import { InputNumber } from 'antd';
import './currencyExchangeRateCell.scss';

interface ICurrencyExchangeRateCell {
  code: string;
  value: number | null;
  onChange: (value: number | null) => void;
}

/**
 * Celda de tasa de cambio con código de moneda e input numérico editable.
 */
const CurrencyExchangeRateCell = ({ code, value, onChange }: ICurrencyExchangeRateCell) => {
  const hasExchangeRate = value !== null;
  const cellClassName = hasExchangeRate ? 'currencyExchangeRateCell hasExchangeRate' : 'currencyExchangeRateCell';

  return (
    <div className={cellClassName}>
      <div className="labelInput">{code}</div>
      <InputNumber
        onChange={(value) => onChange(value as number | null)}
        placeholder="1"
        value={value ?? undefined}
        className="numberInput"
      />
    </div>
  );
};

export default CurrencyExchangeRateCell;
